import { Controller } from 'stimulus';
import morphdom from 'morphdom';
import { render } from 'preact';
import RequestQueue from '../classes/RequestQueue';
import MitreTable from '../utils/mitre-table';


const PREACT_COMPONENTS_SELECTORS = ['[data-table-target*="stickyCheckbox"]'];

class TableStickyRowController extends Controller {
  tableIdentifier = "m-table";
  tableApiIdentifier = "t";

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    if(this.element.dataset['tableIdentifier']) {
      this.tableIdentifier = this.element.dataset['tableIdentifier'];
    }

    if(this.element.dataset['tableApiIdentifier']) {
      this.tableApiIdentifier = this.element.dataset['tableApiIdentifier'];
    }
  }

  connect() {
    this._handleTableStickyRowUpdate = () => this._updateRow();

    this._mitreTable.on('table-sticky-row-update', this._handleTableStickyRowUpdate);
  }

  disconnect() {
    this._mitreTable.removeListener('table-sticky-row-update', this._handleTableStickyRowUpdate);
  }

  async _updateRow() {
    const { collectionKey, currentTabKey, theme } = this._mitreTable.getParams();

    // Retrieve current styles on the element
      try {
        const response = await RequestQueue.addToQueue({
          url: `/api/${this.tableApiIdentifier}/sticky_row.html/`,
          method: 'post',
          data: {
            row_index: this.element.getAttribute('data-table-row-index'),
            symbol: this.element.getAttribute('data-uuid'),
            tab: currentTabKey,
            uuid: this._mitreTable.tableKey,
            theme,
            collection: collectionKey
          }
        });
        const { data } = response;
        const parser = new DOMParser();
        // // get existing element
        const prev = this.element;
        // // create the new element
        const fragment = parser.parseFromString(data, 'text/html').body;
        // // cleanup preact components
        this.unmountComponents(prev);
        // // render on screen - update the DOM
        const result = morphdom(prev, fragment);
        morphdom(result, result.firstChild);

        this._mitreTable.emit('table-sticky-row-update-complete');
      } catch(e) {
        // continue regardless of error
      }
  }

  unmountComponents(parentNode) {
    PREACT_COMPONENTS_SELECTORS.forEach(selector => {
      parentNode.querySelectorAll(selector).forEach(e => render(null, e.parentNode, e));
    });
  }
}

export default TableStickyRowController;
